import { makeUseAxios } from 'axios-hooks';

import { jsonboxAxios } from './axios';

const useJsonboxAxios = makeUseAxios({ axios: jsonboxAxios });

export { useJsonboxAxios };
